import { IntlProvider } from "react-intl";
import { type ReactNode, useEffect, useState } from "react";

import { DEFAULT_LOCALE, detectLocale, type SupportedLocale } from "./locales";

type Messages = Record<string, string>;

const loaders: Record<SupportedLocale, () => Promise<{ default: Messages }>> = {
  en: () => import("@/locales/en.json"),
  es: () => import("@/locales/es.json"),
};

export function IntlProviderWrapper({ children }: { children: ReactNode }) {
  const [locale] = useState<SupportedLocale>(() => detectLocale());
  const [messages, setMessages] = useState<Messages | null>(null);

  useEffect(() => {
    let cancelled = false;
    loaders[locale]().then((m) => {
      if (!cancelled) setMessages(m.default);
    });
    return () => {
      cancelled = true;
    };
  }, [locale]);

  if (!messages) return null;

  return (
    <IntlProvider
      locale={locale}
      defaultLocale={DEFAULT_LOCALE}
      messages={messages}
      onError={(err) => {
        // Missing translations log only — defaultMessage will render.
        if (err.code === "MISSING_TRANSLATION") return;
        console.error(err);
      }}
    >
      {children}
    </IntlProvider>
  );
}
